import { css } from 'styled-components';
import token from 'styled-token';
import { StyledTableHeaderCell } from '../../components/TableHeaderCell/TableHeaderCell.styles';

/** @class TableHeaderMixin */
/** @method */
export var TableHeaderMixin = function TableHeaderMixin(props) {
  return token(props.appearance === 'dark' ? 'Table.headerBackgroundColorDark' : 'Table.headerBackgroundColorLight', function (backgroundColor) {
    return css(["", "{background-color:", ";}"], StyledTableHeaderCell, backgroundColor);
  })(props);
};